import type { ReactNode } from "react"
import { AppContent } from "@/components/app-content"
import { AppSidebar } from "@/components/app-sidebar"
import { AppSidebarHeader } from "@/components/app-sidebar-header"
import { ThemeProvider } from "@/components/theme-provider"

export interface BreadcrumbItem {
  title: string
  href?: string
}

export default function ProjectLayout({
  children,
  breadcrumbs = [],
  projectId,
}: {
  children: ReactNode
  breadcrumbs?: BreadcrumbItem[]
  projectId: string
}) {
  return (
    <ThemeProvider>
      <div className="flex min-h-screen w-full">
        <AppSidebar projectId={projectId} />
        <AppContent variant="sidebar">
          <AppSidebarHeader breadcrumbs={breadcrumbs} />
          {children}
        </AppContent>
      </div>
    </ThemeProvider>
  )
}
